<app-doc-viewer
  title="Spatial Filter"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/spatial-filter">
    <mat-grid-list cols="2" rowHeight="500px" gutterSize="16px">
      <mat-grid-tile>
        <igo-map-browser
          [map]="map"
          [view]="view"
          igoQuery
          [queryFeatures]="true"
        >
          <div class="map-actions --vertical --bottom --right">
            <igo-zoom-button [map]="map" color="primary" />
          </div>
        </igo-map-browser>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="flex flex-col align-start h-100 w-100 overflow-y-auto">
          <igo-panel class="w-100">
            <igo-spatial-filter-type
              [store]="spatialListStore"
              [selectedQueryType]="queryType"
              [layers]="activeLayers"
              (eventType)="getOutputType($event)"
              (eventQueryType)="getOutputQueryType($event)"
              (zonesWithBufferChange)="onAddZone($event, true)"
              (bufferChange)="buffer = $event"
              (measureUnitChange)="measureUnit = $event"
              [zones]="zones"
              (addZone)="onAddZone($event)"
              (removeZone)="onRemovedZone($event)"
            />

            <igo-spatial-filter-item
              [type]="type()"
              [queryType]="queryType"
              [map]="map"
              [zones]="zones"
              [loading]="loading"
              [store]="$any(store)"
              [layers]="activeLayers"
              [allLayers]="layers"
              [thematicLength]="thematicLength"
              (radiusEvent)="buffer = $event"
              (bufferEvent)="buffer = $event"
              (measureUnitChange)="measureUnit = $event"
              (freehandControl)="freehandDrawIsActive.set($event)"
              (drawZoneEvent)="onDrawZoneChange($event)"
              (zonesWithBufferChange)="onAddZone($event, true)"
              (itemTypeChange)="itemType.set($event)"
              (thematicChange)="thematics = $event"
              (toggleSearch)="getOutputToggleSearch()"
              (clearButtonEvent)="clearMap()"
              (clearSearchEvent)="getOutputClearSearch()"
            />
          </igo-panel>

          <igo-panel class="w-100">
            @if (selectedFeature$ | async; as feature) {
              <igo-feature-details [feature]="feature" />
            }
          </igo-panel>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </app-example-viewer>
</app-doc-viewer>
